import { ApiGetRequest } from '../../api';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Dashboard Finance',
    items: [
      {
        text: 'Dashboard',
        href: '/',
      },
    ],
    total_piutang: 0,
    loading_piutang: false,
    total_hutang: 0,
    loading_hutang: false,
    total_kas_masuk: 0,
    loading_kas_masuk: false,
    total_kas_keluar: 0,
    loading_kas_keluar: false,
    loading_pendapatan: false,
    loading_pendapatan_kota: false,
    data_bulan: moment().format('M'),
    earningLineChart: {
      series: [
        {
          name: 'Pendapatan Harian',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 320,
          type: 'line',
          toolbar: 'false',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#26366f'],
        stroke: {
          curve: 'smooth',
          width: 3,
        },
      },
    },
    salesAnalyticsDonutChart: {
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          height: 240,
        },
        labels: [],
        // colors: ['#556ee6', '#34c38f', '#f46a6a'],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
            },
          },
        },
      },
    },
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getTotalPiutang({ commit }) {
    commit('changeDashboard', {
      loading_piutang: true,
    });

    let result = await ApiGetRequest(`fin/dashboard/total-piutang`);
    commit('changeDashboard', {
      total_piutang: result.error ? 0 : result.data.object,
      loading_piutang: false,
    });

    return !result.error ? true : false;
  },

  async getTotalHutang({ commit }) {
    commit('changeDashboard', {
      loading_hutang: true,
    });

    let result = await ApiGetRequest(`fin/dashboard/total-hutang`);
    commit('changeDashboard', {
      total_hutang: result.error ? 0 : result.data.object,
      loading_hutang: false,
    });

    return !result.error ? true : false;
  },

  async getTotalKasMasuk({ commit }) {
    commit('changeDashboard', {
      loading_kas_masuk: true,
    });

    let result = await ApiGetRequest(`fin/dashboard/total-kas-masuk`);
    commit('changeDashboard', {
      total_kas_masuk: result.error ? 0 : result.data.object,
      loading_kas_masuk: false,
    });

    return !result.error ? true : false;
  },

  async getTotalKasKeluar({ commit }) {
    commit('changeDashboard', {
      loading_kas_keluar: true,
    });

    let result = await ApiGetRequest(`fin/dashboard/total-kas-keluar`);
    commit('changeDashboard', {
      total_kas_keluar: result.error ? 0 : result.data.object,
      loading_kas_keluar: false,
    });

    return !result.error ? true : false;
  },

  async getTotalPendapatanHarian({ commit, state }) {
    commit('changeDashboard', {
      loading_pendapatan: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/dashboard/pendapatan-harian`, {
      bulan: data.data_bulan ? data.data_bulan : 0,
    });
    commit('changeDashboard', {
      earningLineChart: {
        ...data.earningLineChart,
        series: result.error ? [] : [result.data.object],
      },
      loading_pendapatan: false,
    });

    return !result.error ? true : false;
  },

  async getTotalPendapatanKota({ commit, state }) {
    commit('changeDashboard', {
      loading_pendapatan_kota: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/dashboard/pendapatan-kota`, {
      bulan: data.data_bulan ? data.data_bulan : 0,
    });
    commit('changeDashboard', {
      salesAnalyticsDonutChart: {
        ...data.salesAnalyticsDonutChart,
        series: result.error ? [] : result.data.object.series,
        chartOptions: {
          ...data.salesAnalyticsDonutChart.chartOptions,
          labels: result.error ? [] : result.data.object.labels,
        },
      },
      label_series: result.error ? [] : result.data.object.label_series,
      loading_pendapatan_kota: false,
    });

    return !result.error ? true : false;
  },
};
